import React, { ReactNode, MouseEvent, KeyboardEvent } from "react";
import cn from "classnames";
import styles from "./auto-match-blueprint-button.module.scss";
import { ToolTip } from "@components/atoms/tooltip/tooltip";
import { Icon } from "../icon/icon";

interface AutoMatchBlueprintButtonPropTypes {
  fun: (e?: MouseEvent | KeyboardEvent) => void;
  iconName?: string;
  text: string | ReactNode;
  type?: "button" | "submit" | "reset";
  variant?: string | string[];
  tooltip?: string;
  disabled?: boolean;
}

const cssClassName = "auto-match-blueprint-button";
const DEFAULT_HEIGHT = 24;
const DEFAULT_WIDTH = 24;

export const AutoMatchBlueprintButton = ({
  fun,
  iconName = "sparkles_solid",
  text,
  type = "submit",
  tooltip = "",
  disabled = false,
}: AutoMatchBlueprintButtonPropTypes) => {
  const button = (
    <button
      type={type}
      onClick={fun}
      className={cn(styles[cssClassName], {
        [styles[`${cssClassName}--disabled`]]: disabled,
      })}
      disabled={disabled}
    >
      <Icon name={iconName} width={DEFAULT_WIDTH} height={DEFAULT_HEIGHT} />
      {text}
    </button>
  );

  return tooltip ? <ToolTip content={tooltip}>{button}</ToolTip> : button;
};
